import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// 邮箱通道
export function emailChannelList(data) { return axios.post(`${base.url}/cloud/email/channel/list`, qs.stringify(data)) }
export function emailChannelDetail(id) { return axios.post(`${base.url}/cloud/email/channel/detail`, qs.stringify({ id })) }
export function emailChannelAddOrUpdate(data) { return axios.post(`${base.url}/cloud/email/channel/addOrUpdate`, qs.stringify(data)) }
export function emailChannelStatus(id, status) { return axios.post(`${base.url}/cloud/email/channel/status`, qs.stringify({ id, status })) }
export function emailChannelDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/email/channel/deleteBatchIds`, qs.stringify({ ids })) }

// 邮箱模版
export function emailTemplateList(data) { return axios.post(`${base.url}/cloud/email/template/list`, qs.stringify(data)) }
export function emailTemplateDetail(id) { return axios.post(`${base.url}/cloud/email/template/detail`, qs.stringify({ id })) }
export function emailTemplateAddOrUpdate(data) { return axios.post(`${base.url}/cloud/email/template/addOrUpdate`, qs.stringify(data)) }
export function emailTemplateStatus(id, status) { return axios.post(`${base.url}/cloud/email/template/status`, qs.stringify({ id, status })) }
export function emailTemplateDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/email/template/deleteBatchIds`, qs.stringify({ ids })) }
export function emailTemplateBatchImport(data) { return axios.post(`${base.url}/cloud/email/template/batchImport`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function emailTemplateTestSend(templateId, email, operator) { return axios.post(`${base.url}/cloud/email/template/testSend`, qs.stringify({ templateId, email, operator })) }

// 邮箱发送记录
export function emailLogList(data) { return axios.post(`${base.url}/cloud/email/log/list`, qs.stringify(data)) }
export function emailLogDetail(id) { return axios.post(`${base.url}/cloud/email/log/detail`, qs.stringify({ id })) }
export function emailLogDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/email/log/deleteBatchIds`, qs.stringify({ ids })) }
export function emailLogResend(id, operator) { return axios.post(`${base.url}/cloud/email/log/resend`, qs.stringify({ id, operator })) }

// 验证码规则
export function emailRuleList(data) { return axios.post(`${base.url}/cloud/email/rule/list`, qs.stringify(data)) }
export function emailRuleAddOrUpdate(data) { return axios.post(`${base.url}/cloud/email/rule/addOrUpdate`, qs.stringify(data)) }

// 规则变更历史
export function emailRuleLogList(data) { return axios.post(`${base.url}/cloud/email/ruleLog/list`, qs.stringify(data)) }
